import "../styles/story.css";
// import storyImage from '../../images/mapMarker.webp'

export default function Twentyfour() {
  return (
    <div className="containerStory">
      <div className="storyHeading">
        <h2>2024</h2>
        {/* <img src={storyImage} alt="Tubbees Wishaw store" /> */}
      </div>

      <p>
        We opened another new store in Wishaw.
        <br />
        <span>
          We also expanded our drinks range with iced matcha and a brand-new
          coffee menu.
        </span>
      </p>
    </div>
  );
}